import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import useDirection from "src/shared/hooks/useDirection";
import "./index.less";

const LoyalityLevelCard = ({ item, findTrustCard }: any) => {
  const { t } = useTranslation();
  const { id, name, percent, showPrice } = item;
  const { priceSeprator } = useDirection();

  return (
    <Col xs={8} lg={3} className="colMainLoyalityLevelCard">
      <Row
        className="rowMainBox"
        style={{
          background:
            Number(findTrustCard) == Number(id)
              ? "rgba(255, 217, 0, 1)"
              : "rgba(238, 238, 238, 0.3)",
          boxShadow:
            Number(findTrustCard) == Number(id)
              ? "0px 0px 20px 5px rgba(255, 217, 0, 0.4)"
              : "",
          transform:
            Number(findTrustCard) == Number(id) ? "scale(1.1)" : "scale(1)",
        }}
        justify="center"
        gutter={[0, 10]}
      >
        <Col
          style={{
            color: "#000",
          }}
          className="name"
          span={24}
        >
          {name}
        </Col>
        <Col span={24}>
          <div className="percentContent"> {t("refund")} </div>
          <div className="percentNumber"> %{percent} </div>
        </Col>
        <Col className="price" span={24}>
          {showPrice}
        </Col>
      </Row>
    </Col>
  );
};

export default LoyalityLevelCard;
